import { ColoredAlert, Footer } from '@bpinternal/ui-kit-next'
import { FC } from 'react'
import { useCopyToBot } from '~/hooks/bots/useCopyToBot'
import { trackEvent } from '~/providers'

type CopyToBotDialogProps = {
  close: () => void
  workspaceId: string
  sourceBotName: string
  targetBotName: string
  sourceBotId: string
  targetBotId: string
}

export const CopyToBotDialog: FC<CopyToBotDialogProps> = ({
  close,
  workspaceId,
  sourceBotName,
  targetBotName,
  sourceBotId,
  targetBotId,
}) => {
  const { mutate: copyBot, isPending: isCopying } = useCopyToBot()

  return (
    <div className="flex flex-col gap-2">
      <>
        <ColoredAlert color="amber">
          <p className="text-sm">
            This will copy all settings and workflows from &quot;{sourceBotName}&quot; to &quot;{targetBotName}
            &quot;. This cannot be undone.
          </p>
        </ColoredAlert>
        <Footer
          disabled={isCopying}
          showCancel
          confirmLabel="Copy"
          onCancel={close}
          onConfirm={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault()
            trackEvent({
              type: 'request_copy_to_bot_from_dashboard',
              sourceBotId,
              targetBotId,
            })
            copyBot({
              workspaceId,
              sourceBotId,
              targetBotId,
              onSettled: close,
              onSuccess: () => {
                trackEvent({
                  type: 'copy_to_bot_success_from_dashboard',
                  sourceBotId,
                  targetBotId,
                })
              },
              onError: (error) => {
                trackEvent({
                  type: 'copy_to_bot_error_from_dashboard',
                  sourceBotId,
                  targetBotId,
                  error: error.message,
                })
              },
            })
          }}
        />
      </>
    </div>
  )
}
